<template>
  <footer class="sec-mt">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-2">
          <p class="logo">IAAMC</p>
        </div>
        <div class="col-md-2">
          <ul>
            <li v-if="header[0] ? header[0].status : false">
              <router-link to="/accreditations" style="float: unset"
                >Accreditation</router-link
              >
            </li>
            <li v-if="header[1] ? header[1].status : false">
              <router-link to="/programs" style="float: unset"
                >Programs</router-link
              >
            </li>
            <li v-if="header[2] ? header[2].status : false">
              <router-link to="/memberships" style="float: unset"
                >Membership</router-link
              >
            </li>
          </ul>
        </div>
        <div class="col-md-2">
          <ul>
            <li v-if="header[3] ? header[3].status : false">
              <router-link to="/about" style="float: unset">About</router-link>
            </li>
            <li v-if="header[4] ? header[4].status : false">
              <router-link to="/contact" style="float: unset"
                >Contact Us</router-link
              >
            </li>
            <li v-if="header[7] ? header[7].status : false">
              <router-link to="/online-trainings" style="float: unset"
                >Online Training</router-link
              >
            </li>
          </ul>
        </div>
        <div class="col-md-2">
          <ul>
            <li v-if="header[8] ? header[8].status : false">
              <router-link to="/our-certificates" style="float: unset"
                >Certification</router-link
              >
            </li>
            <li v-if="header[6] ? header[6].status : false">
              <router-link to="/events" style="float: unset"
                >Events &amp; Conferences</router-link
              >
            </li>

            <li
              v-for="(pg, idx) in pages"
              :key="idx"
              :class="pg.has_footer ? '' : 'hidden'"
            >
              <router-link
                :to="{ name: 'show-page', params: { slug: pg.slug } }"
                style="float: unset"
              >
                {{ pg.title }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-4">
          <div class="iaa-newsletter">
            <div class="bg-title mb-2">News</div>
            <div class="iaa-search mb-2 d-flex justify-content-between">
              <input v-model="email" type="text" placeholder="Your mail here" />
              <button @click="newsletter" class="subscribe-btn">
                <div class="d-flex align-items-center">
                  Subscribe <span class="icon-arrow-right ml-2"></span>
                </div>
              </button>
            </div>
            <div v-if="success" style="color: #080" class="alert-msg">
              email sent successfully.
            </div>
            <div v-if="error" style="color: #f00" class="alert-msg">
              this email not valid.
            </div>
          </div>
        </div>
      </div>
      <hr class="line" />
      <div class="footer-bottom">
        <div class="text">
          2021 All Rights Reserved © IAAMC International Academy for Art, Media
          and Creativity
          <router-link
            v-if="header[5] ? header[5].status : false"
            to="/privacy"
            class="footer-link"
            >Privacy Policy</router-link
          >
        </div>
        <div class="socialmedia d-flex align-items-center">
          <div class="follow-text">Follow Us</div>
          <a
            v-for="(social, index) in rows"
            class="social-icon"
            :href="social.provider_url"
            :key="index"
            target="_blank"
          >
            <i
              v-if="social.provider.toLowerCase() == 'facebook'"
              class="fab fa-facebook-f"
            ></i>
            <i
              v-if="social.provider.toLowerCase() == 'youtube'"
              class="fab fa-youtube"
            ></i>
            <i
              v-if="social.provider.toLowerCase() == 'linkedin'"
              class="fab fa-linkedin-in"
            ></i>
            <i
              v-if="social.provider.toLowerCase() == 'twitter'"
              class="fab fa-twitter"
            ></i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.alert-msg {
  padding: 10px 0;
  font-size: 17px;
}
</style>

<style scoped>
.hidden {
  display: none !important;
}
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  align-items: center;
  line-height: 1;
}
.footer .text {
  color: #555555;
  font-size: 14px;
  margin-right: 13px;
  line-height: 1;
  font-weight: 600;
}
.follow-text {
  color: #393939
}
.bg-title {
  font-size: 23px;
}
.iaa-search input {
  background: #fff;
  padding: 7px 15px;
  height: 38px;
}
.subscribe-btn {
  background: #fff;
  color: #000;
  padding: 0 19px;
  border: 1px solid #fff;
  height: 38px;
}
.subscribe-btn:hover {
  background: #000;
  color: #fff;
}
.icon-arrow-right {
  font-weight: bold;
  font-size: 17px;
}
.footer ul li a {
  float: unset !important;
}
.footer ul {
  margin-left: 40px;
}

.footer-social {
  display: flex;
  align-items: center;
}

.social-icon {
  font-size: 13.5px;
  color: #555;
  margin-left: 13px;
  line-height: 1;
}
.social-icon:hover {
  color: #4f17a8;
}
.footer-link {
  color: #555555;
  font-size: 14px;
  margin-right: 30px;
  font-weight: 600;
}
.footer-link:hover {
  color: #4f17a8;
}
.footer-links {
  display: none;
}
.containerFluidHome {
  padding: 0;
}
.containerFluidHome .footer-copyright {
  display: none !important;
}
.containerFluidHome .footer-links {
  display: block !important;
}
.footerNavbar {
  padding: 13px 0;
}
.footerNavbar .container-fluid {
  padding: 0;
}
.footerNavbar .footer-copyright > div,
.footerNavbar .text,
.footerNavbar i {
  color: #999;
}
/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
}

@media (max-width: 767.98px) {
  .footer-copyright > div {
    font-size: 12px;
  }
  .footer-copyright > div:first-of-type {
    display: none;
  }
  .footer {
    padding: 13px 0;
  }
  .footer .text {
    font-size: 13px;
    margin-right: 2px;
  }
  .containerFluidHome .footer-copyright {
    display: block !important;
  }
  .containerFluidHome .footer-links {
    display: none !important;
  }
  .containerFluidHome div,
  .containerFluidHome a,
  .containerFluidHome i,
  .containerFluidHome .text {
    color: #848484;
  }
  /* footer div[class*="col-"] {
      padding-left: 0;
      padding-right: 0;
    } */
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>

<script>
import axios from "axios";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      rows: [],
      pages: [],
      header: [],
      email: "",
      success: false,
      error: false,
    };
  },
  props: ["has_links", "containerFluidHome", "footerNavbar"],
  created() {
    axios
      .get(window.baseURL + "/setting")
      .then((res) => {
        this.rows = res.data.social;
        this.header = res.data.header;
      })
      .catch(() => {});

    axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
  },
  methods: {
    newsletter() {
      const options = {
        url: window.baseURL + "/newsletters",
        method: "POST",
        data: {
          email: this.email,
        },
      };

      axios(options)
        .then((res) => {
          console.log(res);
          this.email = "";
          this.success = true;
          this.error = false;
        })
        .catch((err) => {
          console.log(err);
          this.success = false;
          this.error = true;
        });
    },
  },
};
</script>
